<template>
  <div class="container-fluid mt-4">
    <div class="row">
      <div class="col-sm-12 col-md-6 col-lg-4" v-for="service in services" :key="service.name" @click="goToDetail(service.slug)">
        <div class="card mb-4">
          <div class="card-body d-flex">
            <div class="icon-folder">
              <i class="bi bi-building"></i>
            </div>
            <div class="right-content">
              <h5 class="card-title text-left">{{ service.name }}</h5>
              <p class="card-text card-description text-left">{{ limitText(service.description, 70) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ServicesList',
  props: {
    services: {
      type: Array,
      required: true
    }
  },
  methods: {
    goToDetail(slug) {
      this.$router.push(`/detail/${slug}`);
    },
    limitText(text, limit) {
      return text.length > limit ? text.substring(0, limit) + '...' : text;
    }
  }
}
</script>

<style scoped>
/* Add custom styles here if needed */
.text-left {
  text-align: left;
}
.card {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f9f9f9;
}
.card-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 0.5rem;
  color: #333;
  border-bottom: 1px solid #ddd;
  padding-bottom: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
}
.icon-folder {
  font-size: 2rem;
  color: #52B6BA;
  margin-right: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-description {
  font-size: 0.8rem;
  color: #666;
}
.right-content {
  flex: 1;
}
</style>